import axios from 'axios';

export function getAllGalleryImages(page = 1) {
  return axios.get(`/api/?entity=gallery&action=getAllImages&page=${page}`).then(response => response.data);
}
